import React from 'react'
import { useTranslation } from 'react-i18next'
import { constants } from '../../../../utils/constants'
import { DownloadIcon, CheckIcon } from '../../../shared-components/Icons'
import { AnimationContainer } from '../../../shared-components/AnimationContainer'
import styles from './LicensesSection.module.scss'

export const LicensesSection = () => {
  const { t } = useTranslation()

  const formats = [
    {
      image: constants.crop_png,
      format: "PNG",
      title: t('PNG file format'),
      description: "Perfect for transparent backgrounds and web graphics",
      features: ["Transparent backgrounds", "Lossless compression", "Web optimized"],
      color: "primary"
    },
    {
      image: constants.crop_eps,
      format: "EPS", 
      title: t('EPS file format'),
      description: "Vector format ideal for scalable graphics and print",
      features: ["Infinitely scalable", "Print ready", "Vector graphics"],
      color: "secondary"
    },
    {
      image: constants.crop_jpg,
      format: "JPG",
      title: t('JPG file format'), 
      description: "High-quality photos perfect for digital and print use",
      features: ["High resolution", "Small file sizes", "Universal compatibility"],
      color: "blue"
    }
  ]

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <AnimationContainer animationStyle="animate">
          <div className={styles.header}>
            <h2 className={`${styles.title} title`}>
              {t('Licenses_Formats')}
            </h2>
            <p className={`${styles.description} description`}>
              {t('Licenses_Formats_Description')}
            </p>
          </div>
        </AnimationContainer>

        <div className={styles.formatsGrid}>
          {formats.map((format, index) => (
            <AnimationContainer key={index} animationStyle="animate">
              <div className={`${styles.formatCard} ${styles[format.color]}`}>
                <div className={styles.imageContainer}>
                  <img 
                    src={format.image} 
                    alt={format.title}
                    className={styles.formatImage}
                  />
                  <div className={styles.formatBadge}>
                    {format.format}
                  </div>
                </div>
                
                <div className={styles.formatContent}>
                  <h3 className={styles.formatTitle}>
                    {format.title}
                  </h3>
                  <p className={styles.formatDescription}>
                    {format.description}
                  </p>
                  <div className={styles.featuresList}>
                    {format.features.map((feature, idx) => (
                      <div key={idx} className={styles.featureItem}>
                        <CheckIcon className={styles.checkIcon} />
                        {feature}
                      </div>
                    ))}
                  </div>
                  {/* <button className={`${styles.selectButton} button`}>
                    Select Format
                  </button> */}
                </div>
              </div>
            </AnimationContainer>
          ))}
        </div>

        {/* Additional info section */}
        <AnimationContainer animationStyle="animate">
          <div className={styles.licensingInfo}>
            <div className={styles.licensingCard}>
              <div className={styles.licensingHeader}>
                <h3 className={styles.licensingTitle}>
                  Simple, Transparent Licensing
                </h3>
                <div className={styles.licensingIcon}>
                  <CheckIcon style={{ width: 30}} />
                </div>
              </div>
              <p className={styles.licensingDescription}>
                All our images come with clear licensing terms. Use them for commercial projects, 
                marketing materials, websites, and more without worrying about copyright issues.
              </p>
              <div className={styles.licensingFeatures}>
                <div className={styles.licensingFeature}>
                  <CheckIcon className={styles.checkIcon} />
                  <span>Commercial use allowed</span>
                </div>
                <div className={styles.licensingFeature}>
                  <CheckIcon className={styles.checkIcon} />
                  <span>No attribution required</span>
                </div>
                <div className={styles.licensingFeature}>
                  <CheckIcon className={styles.checkIcon} />
                  <span>Worldwide licensing</span>
                </div>
              </div>
              <a href="/legal/terms-and-conditions" target='_blank' className={`${styles.learnMoreButton} button buttonSelected`}>
                Learn More About Licensing
              </a>
            </div>
          </div>
        </AnimationContainer>
      </div>
    </div>
  )
}